import Vue from 'vue'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { convertDateStringToUTCDate } from '@/utils/dateUtil'
import facilityEventHub from '@/components/facility/FacilityEventHub';

export default Vue.component('facility-specialty-summary-card', {
  name: 'FacilitySpecialtySummaryCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      credentialedProviders: emptyArray,
      facilitySpecialtyRates: [],
      facilitySpecialtyProviderRequirements: [],
      facilitySpecialtyBoardCertificationRequirements: [],
      facilitySpecialtyCertificationRequirements: [],
      facilitySpecialtyContacts: [],
    }
  },
  components: {
    VueSimpleSpinner,
  },
  beforeMount: function () {
    // this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {    
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
    facilityEventHub.$on('SPECIALTY_CONTACT_CHANGE', this.specialtyContactChangeEvent)
    this.expandCard();
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
    facilityEventHub.$off('SPECIALTY_CONTACT_CHANGE', this.specialtyContactChangeEvent)
  },
  filters: {
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    phoneNumberExtension (extension: any) {
      if (!extension) { return ''; }
      return '(' + extension + ')';
    },
    providerRequirementDescription (description: any) {
      if (!description) { return ''; }
      return ' - ' + description;
    },
    providerCertificationDescription (description: any) {
      if (!description) { return ''; }
      return ' - ' + description;
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getCredentialedProviders();
        this.getFacilitySpecialtyRates();
        this.getFacilitySpecialtyProviderRequirements();
        this.getFacilitySpecialtyBoardCertificationRequirements();
        this.getFacilitySpecialtyCertificationRequirements();
        this.getFacilitySpecialtyContacts();
      }
    },
    specialtyChangeEvent () {
      let self = this;
      setTimeout( function () { 
        if (self.cardExpanded) {
          self.getCredentialedProviders();
          self.getFacilitySpecialtyRates();
          self.getFacilitySpecialtyProviderRequirements();
          self.getFacilitySpecialtyBoardCertificationRequirements();
          self.getFacilitySpecialtyCertificationRequirements();
          self.getFacilitySpecialtyContacts();
        }
      }, 1);
    },
    specialtyContactChangeEvent () {
      let self = this;
      setTimeout( function () { 
        if (self.cardExpanded) {
          self.getFacilitySpecialtyContacts();
        }
      }, 1);
    },
    getCredentialedProviders () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/credentialed-providers')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Providers.");          
        }
        let freshCredentialedProviders = response.data.data;
        freshCredentialedProviders.forEach( function (credentialedProvider: any) {
          credentialedProvider.isEditing = false;
          credentialedProvider.isNew = false;
          credentialedProvider.updatingData = false;
          credentialedProvider.billRate = '' + credentialedProvider.billRate;
          credentialedProvider.payRate = '' + credentialedProvider.payRate;
          credentialedProvider.issuedDate = convertDateStringToUTCDate(credentialedProvider.issuedDate);
          credentialedProvider.expirationDate = convertDateStringToUTCDate(credentialedProvider.expirationDate);
          credentialedProvider.expirationNoticeDate = credentialedProvider.expirationNoticeDate ? convertDateStringToUTCDate(credentialedProvider.expirationNoticeDate) : null ;
          credentialedProvider.expirationNoticeSentDate = convertDateStringToUTCDate(credentialedProvider.expirationNoticeSentDate);
        });

        self.credentialedProviders = freshCredentialedProviders;
      })
      .catch(function (err) {
        console.log('response Error! ' + err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Credentialed Providers.'
        });
      })
    },
    getFacilitySpecialtyRates () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/rates')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Specialty Rates.");          
        }
        self.facilitySpecialtyRates = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Rates.'
        });
      })
    },
    getFacilitySpecialtyProviderRequirements () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/getProviderTypes/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Specialty Provider Requirements.");          
        }
        self.facilitySpecialtyProviderRequirements = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Provider Requirements.'
        });
      })
    },
    getFacilitySpecialtyCertificationRequirements () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/getCertificationTypes/')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Specialty Certification Requirements.");          
        }
        self.facilitySpecialtyCertificationRequirements = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Certification Requirements.'
        });
      })
    },
    getFacilitySpecialtyBoardCertificationRequirements () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/requirements')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Specialty Board Certification Requirements.");          
        }
        self.facilitySpecialtyBoardCertificationRequirements = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Board Certification Requirements.'
        });
      })
    },
    getFacilitySpecialtyContacts () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/contacts')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Facility Specialty Contacts.");          
        }
        self.facilitySpecialtyContacts = response.data.data;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Contacts.'
        });
      })
    },
    
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
        // duration: 5000
      });  
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
        // duration: 5000
      });  
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/FacilitySpecialtySummary/FacilitySpecialtySummaryCard.ts